import React from "react";
import { Grid, Button, Typography, Box, Paper } from "@mui/material";
import { MuiOtpInput } from "mui-one-time-password-input";
import mapwalalogo from "../assets/images/logo.png";


const OTPComponent = ({ otp, handleChange, handleOTPSubmit }) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0B1F3A, #123B6D, #1E88E5)",
        px: 2
      }}
    >
      <Grid item xs={12} sm={8} md={5} lg={4}>
        <Paper
          elevation={10}
          sx={{
            p: 4,
            borderRadius: "20px",
            textAlign: "center",
            background: "#ffffff",
            boxShadow: "0 12px 35px rgba(0,0,0,0.18)"
          }}
        >
          {/* Logo */}
          <Box sx={{ mb: 2 }}>
            <img
              src={mapwalalogo}
              alt="Mapwala Logo"
              style={{
                width: "80px",
                height: "80px",
                objectFit: "contain"
              }}
            />
          </Box>

          {/* Heading */}
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              color: "#0B1F3A",
              mb: 1
            }}
          >
            Mapwala
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#666",
              mb: 3
            }}
          >
            Enter the 6-digit OTP sent to your mobile/email
          </Typography>

          {/* OTP Input */}
          <MuiOtpInput
            value={otp}
            onChange={handleChange}
            length={6}
            autoFocus
            TextFieldsProps={{
              size: "medium",
              sx: {
                mx: 0.5,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  background: "#F5F8FF",
                  fontWeight: "bold",
                  fontSize: "20px"
                }
              }
            }}
          />

          {/* Verify Button */}
          <Button
            fullWidth
            color="primary"
            size="large"
            variant="contained"
            onClick={handleOTPSubmit}
            sx={{
              mt: 4,
              py: 1.5,
              borderRadius: "12px",
              fontWeight: "bold",
              fontSize: "16px",
              background: "linear-gradient(90deg, #1565C0, #1E88E5)",
              textTransform: "none",
              boxShadow: "0 8px 20px rgba(30,136,229,0.35)",
              "&:hover": {
                background: "linear-gradient(90deg, #0D47A1, #1565C0)"
              }
            }}
          >
            Verify OTP
          </Button>

          {/* Footer */}
          <Typography
            variant="body2"
            sx={{
              mt: 3,
              color: "#888"
            }}
          >
            Powered by Mapwala Tracking Solutions
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default OTPComponent;